import React from 'react';
import { Container } from './ui/Container';
import { Gift, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function BonusSection() {
  return <section className="py-16 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-hidden" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10" data-id="element-21">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl" data-id="element-22"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-300 rounded-full blur-3xl" data-id="element-23"></div>
      </div>

      <Container className="relative z-10" data-id="element-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-25">
          {/* Left: Book Image */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex justify-center" data-id="element-26">
            <div className="relative" data-id="element-27">
              <img src="https://cdn.magicpatterns.com/uploads/4BGYsWgo5SxPXcZzZJicKi/ChatGPT_Image_Jan_21,_2026,_09_55_50_PM.png" alt="7 Habits to Stop Snoring Naturally - Free Sleep Guide" className="w-full max-w-sm drop-shadow-2xl transform hover:scale-105 transition-transform duration-300" data-id="element-28" />
              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-orange-500 text-white px-4 py-2 rounded-full font-bold text-sm shadow-xl animate-pulse" data-id="element-29">
                $39 VALUE
              </div>
            </div>
          </motion.div>

          {/* Right: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-30">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full" data-id="element-31">
              <Gift className="w-5 h-5 text-orange-400" data-id="element-32" />
              <span className="font-bold text-orange-400 uppercase tracking-wide text-sm" data-id="element-33">
                FREE Bonus Gift
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold leading-tight" data-id="element-34">
              Get Our Exclusive Sleep Guide FREE with Any Purchase
            </h2>

            <p className="text-xl text-blue-100 leading-relaxed" data-id="element-35">
              <span className="font-bold text-white" data-id="element-36">
                "7 Habits to Stop Snoring Naturally"
              </span>{' '}
              — Simple daily changes that make SnoreStop™ work even better.
            </p>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20" data-id="element-37">
              <h3 className="font-bold text-lg mb-4" data-id="element-38">
                Inside this guide, you'll discover:
              </h3>
              <ul className="space-y-3" data-id="element-39">
                {['The #1 sleeping position that reduces snoring by 40%', 'Foods to avoid before bed (they make snoring worse)', 'A 5-minute breathing exercise for clearer airways', 'How to optimize your bedroom for silent sleep', 'The hidden lifestyle factors triggering your snoring', 'Natural supplements that support better breathing', "When to seek professional help (and when you don't need to)"].map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-40">
                    <Check className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-41" />
                    <span className="text-blue-50" data-id="element-42">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-orange-500/20 border-l-4 border-orange-400 p-4 rounded-r-lg" data-id="element-43">
              <p className="font-semibold text-orange-100" data-id="element-44">
                This guide is yours FREE when you order any SnoreStop™ bundle
                today. No extra cost. No catch.
              </p>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>;
}